import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ButtonModule } from '@components/button/button.module';
import { HeaderMenuComponent } from './header-menu.component';
import { DropdownButtonModule } from '@components/dropdown-button/dropdown-button.module';


@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    ButtonModule,
    DropdownButtonModule
  ],
  declarations: [HeaderMenuComponent],
  exports: [HeaderMenuComponent]
})
export class HeaderMenuModule {}
